import React from 'react'
import { Row, Col, Card, CardHeader, CardBody } from "shards-react";

export default function UserSelectionCard({ docs, handleUserSelection, selectedUser }) {

  return (
    <>
      <Row>
        <Col>
          <Card small className="mb-4 ">
            <CardHeader className="border-bottom">
              <h6 className="m-0">Users Selection</h6>
            </CardHeader>
            <CardBody className="p-0 pb-3">
              <table className="table mb-0">
                <thead className="bg-light">
                  <tr>
                    <th scope="col" className="border-0">
                      #
                    </th>
                    <th scope="col" className="border-0">
                       Company
                    </th>
                    <th scope="col" className="border-0">
                       Logo
                    </th>
                  </tr>
                </thead>
                {docs.length > 0 ? (
                  <>
                    <tbody  >
                    {docs && docs.map((doc, index) => (
                        <tr onClick={(e) =>{handleUserSelection(doc.id)}} key={doc.id} className={ selectedUser && doc.id === selectedUser.id ? "focused" : ''}>
                          <td>{index + 1}</td>
                          <td>{doc.username}</td>
                          <td>{doc.displayLogo ? (<img alt={doc.displayLogo.filename} src={doc.displayLogo.url} className="table-logo"/>): 'No Logo'}</td>
                        </tr>
                      
                    ))}
                    </tbody>
                  </>
                ) :
                  (<tbody>
                    <tr>
                      <td>No reports found</td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                  </tbody>
                  )}
              </table>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </>
  )
}
